// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'obje... Remove this comment to see the full error message
import ObjectBuilderClient from 'object-builder-ui-client';
import { CONTACT_TYPE_ID, CONVERSATION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { HUBSPOT_DEFINED } from 'customer-data-objects/associations/AssociationCategoryTypes';
import { CONVERSATIONS, CONVERSATIONS_CONTACT_ASSOCIATION_TYPE_ID } from '../_internal/constants/AppSource';
import { useMemo } from 'react';
import { useGetContactAssociationProps } from '../_internal/hooks/useGetContactAssociationProps';
import { getCrmConversationId } from 'conversations-thread-data/thread-details/public/operators';
import { useThreadDetails } from '../../thread-details-feature/public/hooks/useThreadDetails';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { jsx as _jsx } from "react/jsx-runtime";
const ContactPrompt = ({
  threadId,
  onClose
}) => {
  const {
    asyncThreadDetails
  } = useThreadDetails({
    threadId
  });
  const threadDetails = getData(asyncThreadDetails);
  /*  @ts-expect-error Jun-5-2024, 19:34UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
  const conversationId = getCrmConversationId(threadDetails) || undefined;
  const contactAssociationBuilderExtraProps = useGetContactAssociationProps({
    threadId
  });
  return useMemo(() => /*#__PURE__*/_jsx(ObjectBuilderClient, Object.assign({
    appInfo: {
      defaultAssociation: {
        objectId: `${conversationId}`,
        objectTypeId: CONVERSATION_TYPE_ID,
        associationTypeId: CONVERSATIONS_CONTACT_ASSOCIATION_TYPE_ID
      },
      associationTypeId: CONVERSATIONS_CONTACT_ASSOCIATION_TYPE_ID,
      associationCategory: HUBSPOT_DEFINED
    },
    appName: CONVERSATIONS,
    objectTypeId: CONTACT_TYPE_ID,
    onClose: onClose,
    shouldRenderCreateAndAddButton: false,
    enableFlexibleAssociations: false,
    forceSingleSelectAssociation: true,
    show: true
  }, contactAssociationBuilderExtraProps)), [onClose, conversationId, contactAssociationBuilderExtraProps]);
};
ContactPrompt.displayName = 'ContactPrompt';
export default ContactPrompt;